/**
 *
 * @file 项目管理api
 **/

import AXIOS from '@/utils/$axios';
import { createBrowserHistory } from 'history';

AXIOS.interceptors.response.use(
    response => Promise.resolve(response),
    error => {
        if (error.code === 10003) {
            const his = createBrowserHistory();
            his.push('/user-center/project-space');
            his.go();
        }
        return Promise.reject(error);
    }
);

// 项目列表
export const queryProductList = payload =>
    AXIOS.post(`/space/project/project/project-space`, payload);

// 项目详情
export const queryProductContent = (payload, ignoreCode) =>
    AXIOS.post(`/space/project/common/content`, payload, {
        cancelWarn({ code }) {
            return ignoreCode === code;
        },
    });

// 删除项目
export const removeProject = payload => {
    return AXIOS.post('/space/project/common/delete', payload);
};

// 重命名项目
export const renameProject = payload => {
    return AXIOS.post('/space/project/common/rechristen', payload);
};

//  退出项目
export const exitProject = payload => {
    return AXIOS.post('/space/project/common/exit-project', payload);
};

// 查询设置指引状态
export const getUserGuidance = params => {
    return AXIOS.get('/space/user/guidance', { params });
};
// 查询用户是否需要指引
export const getProjectStatistics = payload => {
    return AXIOS.post('/space/project/project/project-statistics', payload);
};

export const getMockCreateProject = payload => {
    return AXIOS.post('/space/mock/create-project', payload);
};
